import { render, staticRenderFns } from "./GuideItems.vue?vue&type=template&id=68f7e964"
import script from "./GuideItems.vue?vue&type=script&lang=js"
export * from "./GuideItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports